import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OrgProvider } from './contexts/OrgContext';
import { SyncProvider } from './contexts/SyncContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';

// Pages
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { JoinPage } from './pages/auth/JoinPage';
import { DashboardPage } from './pages/DashboardPage';
import { QuickStartPage } from './pages/QuickStartPage';
import { AssetsPageEnhanced as AssetsPage } from './pages/assets/AssetsPageEnhanced';
import { AssetDetailPage } from './pages/assets/AssetDetailPage';
import { AssetInspectionHistoryPage } from './pages/assets/AssetInspectionHistoryPage';
import { CommissionAssetPage } from './pages/assets/CommissionAssetPage';
import { FlocsListPageEnhanced as FlocsListPage } from './pages/flocs/FlocsListPageEnhanced';
import { NewFlocPage } from './pages/flocs/NewFlocPage';
import { EditFlocPage } from './pages/flocs/EditFlocPage';
import { FlocDetailPage } from './pages/flocs/FlocDetailPage';
import { CommissionToFlocPage } from './pages/flocs/CommissionToFlocPage';
import { NameplateCapturePage } from './pages/NameplateCapturePage';
import { TemplatesPage } from './pages/templates/TemplatesPage';
import { TemplateBuilderPage } from './pages/templates/TemplateBuilderPage';
import { MeasurementDefinitionsPage } from './pages/measurement-definitions/MeasurementDefinitionsPage';
import { InspectionsPageEnhanced as InspectionsPage } from './pages/inspections/InspectionsPageEnhanced';
import { NewInspectionPage } from './pages/inspections/NewInspectionPage';
import { InspectionDetailPage } from './pages/inspections/InspectionDetailPage';
import { MyJobsPage } from './pages/MyJobsPage';
import { SchedulesPage } from './pages/schedules/SchedulesPage';
import { BulkOperationsPage } from './pages/BulkOperationsPage';
import { UsersPage } from './pages/UsersPage';
import { InvitationsPage } from './pages/InvitationsPage';
import { ProfilePage } from './pages/ProfilePage';
import { OrganizationSettingsPage } from './pages/OrganizationSettingsPage';
import SapImportPage from './pages/SapImportPage';
import EquipmentImportPage from './pages/EquipmentImportPage';
import { NotFoundPage } from './pages/NotFoundPage';

function App() {
  return (
    <AuthProvider>
      <OrgProvider>
        <SyncProvider>
          <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/join/:token" element={<JoinPage />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="quick-start" element={<QuickStartPage />} />

            {/* Redirect legacy Sites to FLOCs */}
            <Route path="sites" element={<Navigate to="/flocs" replace />} />

            {/* FLOCs */}
            <Route path="flocs" element={<FlocsListPage />} />
            <Route path="flocs/new" element={<NewFlocPage />} />
            <Route path="flocs/:flocId/edit" element={<EditFlocPage />} />
            <Route path="flocs/:flocId/commission" element={<CommissionToFlocPage />} />
            <Route path="flocs/:flocId/capture-nameplate" element={<NameplateCapturePage />} />
            <Route path="flocs/:flocId" element={<FlocDetailPage />} />

            {/* SAP Import */}
            <Route path="sap-import" element={<SapImportPage />} />
            <Route path="equipment-import" element={<EquipmentImportPage />} />

            {/* Assets */}
            <Route path="assets" element={<AssetsPage />} />
            <Route path="assets/:assetId" element={<AssetDetailPage />} />
            <Route path="assets/:assetId/commission" element={<CommissionAssetPage />} />
            <Route path="assets/:assetId/inspections" element={<AssetInspectionHistoryPage />} />

            {/* Templates */}
            <Route path="templates" element={<TemplatesPage />} />
            <Route path="templates/:templateId" element={<TemplateBuilderPage />} />
            <Route path="templates/:templateId/edit" element={<TemplateBuilderPage />} />

            {/* Measurement Definitions */}
            <Route path="measurement-definitions" element={<MeasurementDefinitionsPage />} />

            {/* Inspections */}
            <Route path="inspections" element={<InspectionsPage />} />
            <Route path="inspections/new" element={<NewInspectionPage />} />
            <Route path="inspections/:inspectionId" element={<InspectionDetailPage />} />

            {/* My Jobs (Job Reservation & Sync) */}
            <Route path="my-jobs" element={<MyJobsPage />} />

            {/* Schedules & Other */}
            <Route path="schedules" element={<SchedulesPage />} />
            <Route path="bulk-operations" element={<BulkOperationsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="invitations" element={<InvitationsPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="settings" element={<OrganizationSettingsPage />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </SyncProvider>
      </OrgProvider>
    </AuthProvider>
  );
}

export default App;
